<template>
  <Form ref="patientInfoForm" :model="patientInfoForm" label-position="left" :label-width="100" :rules="rulePatientInfo">
    <input type="hidden" v-model="patientInfoForm.orderId"/>
    <Row v-if="isShowScanCodeInput" type="flex" justify="space-around">
      <Col span="22">
        <FormItem :label="$t('addNewCase.patientInfo.QRCodeInformation')">
          <Input
            style="width: 90%"
            @keydown.native.enter="changeData"
            clearable
            type="text"
            ref="inputFocus"
            :autofocus="true"
            v-model="inputValue"
            :placeholder="$t('addNewCase.patientInfo.QRPlaceholder')"/>
        </FormItem>
      </Col>
    </Row>
    <Row type="flex" justify="space-around">
      <Col span="8">
        <Col span="23">
          <FormItem :label="$t('addNewCase.patientInfo.name')" prop="patName">
            <Input type="text"  maxlength="15" :placeholder="$t('addNewCase.patientInfo.namePlaceholder')" class="inputWidth" v-model="patientInfoForm.patName"></Input>
          </FormItem>
        </Col>
      </Col>
      <Col span="12">
        <FormItem :label="$t('addNewCase.patientInfo.gender')" required>
          <RadioGroup  v-model="patientInfoForm.patSex">
            <Radio  v-for="item in sexs" :value="item.label" :key="item.label" :label="item.label" style="padding-left: 30px">{{ item.value }}</Radio>
          </RadioGroup>
        </FormItem>
      </Col>
    </Row>
    <Row type="flex" justify="space-around">
      <Col span="8">
        <FormItem :label="$t('addNewCase.patientInfo.age')" required>
          <InputNumber :placeholder="$t('addNewCase.patientInfo.agePlaceholder')" class="inputWidth" v-model="patientInfoForm.patAge" :max="200" :min="0" ></InputNumber>
        </FormItem>
      </Col>
      <Col span="12">
        <FormItem :label="$t('addNewCase.patientInfo.consultationNumber')" prop="patVisId">
          <Input type="text" maxlength="20" :placeholder="$t('addNewCase.patientInfo.consultationNumberPlaceholder')" class="inputWidth" v-model="patientInfoForm.patVisId"></Input>
        </FormItem>
      </Col>
    </Row>
    <div v-if="isShowMorePatientInfo">
      <Row type="flex" justify="space-around">
        <Col span="8">
          <FormItem :label="$t('addNewCase.patientInfo.typeOfCertificate')" >
            <Select class="inputWidth" v-model="patientInfoForm.patNoType">
              <Option v-for="(item,index) in zjlxList" :value="item.value" :key="index">{{ item.label }}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('addNewCase.patientInfo.IDNumber')">
            <Input type="text"  maxlength="18" :placeholder="$t('addNewCase.patientInfo.IDNumberPlaceholder')" class="inputWidth" v-model="patientInfoForm.patNo"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="space-around">
        <Col span="8">
          <FormItem :label="$t('addNewCase.patientInfo.medicalInsuranceCardNumber')">
            <Input type="text" maxlength="25" :placeholder="$t('addNewCase.patientInfo.medicalInsuranceCardNumberPlaceholder')" sclass="inputWidth"  v-model="patientInfoForm.patMiid"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('addNewCase.patientInfo.dateOfBirth')" >
            <DatePicker type="date" :placeholder="$t('addNewCase.patientInfo.dateOfBirthPlaceholder')" class="inputWidth" v-model="patientInfoForm.patBirthday" format="yyyy-MM-dd"></DatePicker>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="space-around">
        <Col span="22">
          <FormItem :label="$t('addNewCase.patientInfo.contactNumber')" prop="patTellphone">
            <Input type="text" maxlength="11" :placeholder="$t('addNewCase.patientInfo.contactNumberPlaceholder')" class="inputWidth" v-model="patientInfoForm.patTellphone"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row type="flex" justify="space-around">
        <Col span="22">
          <FormItem :label="$t('addNewCase.patientInfo.address')" label-width:80>
            <Input type="text" maxlength="100" :placeholder="$t('addNewCase.patientInfo.addressPlaceholder')"  class="inputWidth"  v-model="patientInfoForm.patAddress"></Input>
          </FormItem>
        </Col>
      </Row>
    </div>
    <Row @click.native="showMorePatientInfo"><!--  showMorePatientInfo -->
      <Col span="6" style="position: relative; top: -10px;margin-left: 25px">
        <a style="font-size: 16px; font-weight: 500; color: #2db7f5" >
          <span>{{moreText}}</span>
          <Icon v-show="isShowMorePatientInfo === false" type="ios-arrow-down"></Icon>
          <Icon v-show="isShowMorePatientInfo === true" type="ios-arrow-up"></Icon>
        </a>
      </Col>
    </Row>
    <Row style="background-color: #e9eaec;height: 1px">
    </Row>
    <div v-if="isShowGetPatient">
      <Modal
        v-model="isShowGetPatient"
        :closable="false"
        :mask-closable="false"
        scrollable
        width = "500px"
        :title="$t('addNewCase.patientInfo.internetCaseSearch')">
        <div>
          <Input type="text" maxlength="15" :placeholder="$t('addNewCase.patientInfo.checklistNumberPlaceholder')" v-model="checkId"></Input>
        </div>
        <div slot="footer">
          <Button type="primary" size="large"  style="width: 70px" @click="cancel()">{{$t('addNewCase.patientInfo.cancel')}}</Button>
          <Button type="primary" size="large"  style="width: 70px" @click="getPatient()">{{$t('addNewCase.patientInfo.inquire')}}</Button>
        </div>
      </Modal>
    </div>
  </Form>
</template>

<script>
export default {
  name: 'PatientInfo',
  data () {
    // 验证手机号码
    const patTellphone = (rule, value, callback) => {
      let reg = /(^1(2|3|4|5|6|7|8)\d{9}$)/
      if (value === '') {
        callback()
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('addNewCase.patientInfo.correctContactNumber')))
      } else {
        callback()
      }
    }
    return {
      $vue: '',
      isShowScanCodeInput: false, // 是否展示扫描二维码输入框
      moreText: this.$t('addNewCase.moreInformation'),
      isShowMorePatientInfo: false, // 是否显示更多病人信息
      isShowGetPatient: false, // 是否显示查询互联网病例
      checkId: '',
      inputValue: '',
      zjlxList: '',
      // 病人信息
      patientInfoForm: {
        patName: '', // 病人姓名
        patAge: 0, // 病人年龄
        patSex: '0', // 病人性别
        patVisId: '', // 就诊号
        patTellphone: '', // 病人电话
        patBirthday: '', // 出生日期
        patMiid: '', // 医保卡号
        patNoType: '', // 证件类型
        patNo: '', // 证件号码
        patAddress: '', // 住址
        orderId: ''
      },
      // 性别
      sexs: [
        {
          value: this.$t('addNewCase.patientInfo.menAndWomen.male'),
          label: '1'
        },
        {
          value: this.$t('addNewCase.patientInfo.menAndWomen.female'),
          label: '0'
        }
      ],
      rulePatientInfo: {
        patName: [
          { required: true, message: this.$t('addNewCase.patientInfo.namePlaceholder') + '!', trigger: 'change' }
        ],
        patTellphone: [
          { required: false, validator: patTellphone, trigger: 'blur' }
        ]
      }
    }
  },
  beforeMount () {
    this.$vue = this
  },
  mounted () {
    this.isShowScanQRCode()
    this.getDicInfo()
  },
  methods: {
    // 获取是否展示二维码信息扫码框
    async isShowScanQRCode () {
      let params = new URLSearchParams()
      let suc = await this.$http.post(this.$vue.getData('IS_SHOW_SCAN_CODE_URL'), params)
      if (suc.data.result === '1') {
        this.isShowScanCodeInput = (suc.data.data === '1')
        if (this.isShowScanCodeInput) {
          this.$nextTick(() => {
            this.$refs.inputFocus.$el.children[1].focus()
          })
        }
      }
    },
    // 获取后台证件信息字典数据
    async getDicInfo () {
      let params = new URLSearchParams()
      // 证件类型，病理类型，送检部门，染色类型
      let types = 'zjlx'
      params.append('types', types)
      let suc = await this.$http.post(this.$vue.getData('GET_DIC_INFO_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.zjlxList = data.zjlx
      }
    },
    // 显示更多病人信息方法
    showMorePatientInfo () {
      this.isShowMorePatientInfo = !this.isShowMorePatientInfo
      if (this.isShowMorePatientInfo) {
        this.moreText = this.$t('addNewCase.collapseInformation')
      } else {
        this.moreText = this.$t('addNewCase.moreInformation')
      }
    },
    // 校验病人信息方法
    patientHandleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('patientInfo', this.patientInfoForm)
        }
      })
    },
    // 提交病人信息方法
    submitPatientInfo () {
      this.patientHandleSubmit('patientInfoForm')
    },
    goGetPatient () {
      this.isShowGetPatient = true
    },
    // 取消
    cancel () {
      this.isShowGetPatient = false
    },
    getPatient () {
      if (this.checkId) {
        this.getNetPatient(this.checkId)
        this.isShowGetPatient = false
      } else {
        this.$Message.error(this.$t('addNewCase.patientInfo.checklistNumberPlaceholder'))
      }
    },
    async getNetPatient (checkId) {
      let params = new URLSearchParams()
      params.append('checkId', checkId)
      let suc = await this.$http.post(this.$vue.getData('GET_NET_PATIENT_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        console.log(data)
        this.patientInfoForm.patName = data.patient.data.TRUE_NAME
        this.patientInfoForm.patAge = data.patient.data.AGE
        this.patientInfoForm.patTellphone = data.patient.data.PHONE
        if (data.patient.data.SEX) {
          this.patientInfoForm.patSex = '1'
        } else {
          this.patientInfoForm.patSex = '0'
        }
        this.patientInfoForm.patNoType = '0'
        this.patientInfoForm.patNo = data.patient.data.ID_NUMBER
        this.patientInfoForm.patVisId = checkId
        this.patientInfoForm.patBirthday = this.getAgeAndSex(data.patient.data.ID_NUMBER)
        this.patientInfoForm.orderId = data.patient.data.ORDER_ID
        if (data.patient.data.ORDER_STATUS === -1 || data.patient.data.ORDER_STATUS === 0) {
          this.$Message.warning({
            content: this.$t('addNewCase.netPatientNoPaymentTip'),
            duration: 5,
            closable: true
          })
        }
      } else {
        this.$Message.error(this.$t('addNewCase.netPatientNetworkErrorip'))
      }
    },
    // 根据身份证号获取年龄
    getAgeAndSex (identityCard) {
      let len = (identityCard + '').length
      if (len === 0) {
        return 0
      } else {
        if ((len !== 15) && (len !== 18)) { // 身份证号码只能为15位或18位其它不合法
          return 0
        }
      }
      let strBirthday = ''
      if (len === 18) { // 处理18位的身份证号码从号码中得到生日和性别代码
        strBirthday = identityCard.substr(6, 4) + '-' + identityCard.substr(10, 2) + '-' + identityCard.substr(12, 2)
      }
      if (len === 15) {
        strBirthday = '19' + identityCard.substr(6, 2) + '-' + identityCard.substr(8, 2) + '-' + identityCard.substr(10, 2)
      }
      console.log(strBirthday)
      return strBirthday
    },
    /**
     * 获取二维码中的数据，截取并赋值
     */
    async changeData () {
      if (this.inputValue.indexOf('DB') === 0) {
        let params = new URLSearchParams()
        params.append('orderNum', this.inputValue)
        let suc = await this.$http.post(this.$vue.getData('GET_EPS_PATIENT_URL'), params)
        if (suc.data.result === '1') {
          let data = suc.data.data
          this.patientInfoForm.orderId = data.patient.data.ORDER_ID
          this.patientInfoForm.patName = data.patient.data.USER_NAME
          this.patientInfoForm.patSex = data.patient.data.USER_SEX === '男' ? '1' : '0'
          this.patientInfoForm.patAge = data.patient.data.USER_AGE
          this.patientInfoForm.patNoType = '0'
          this.patientInfoForm.patNo = data.patient.data.USER_ID_NUMBER
          this.patientInfoForm.patTellphone = data.patient.data.USER_PHONE
        } else {
          this.$Message.warning({
            content: this.$t('addNewCase.orderNotExistTip'),
            duration: 5,
            closable: true
          })
        }
      } else {
        let inputArray = []
        if (this.inputValue.indexOf('；') !== -1) {
          inputArray = this.inputValue.split('；')
        } else if (this.inputValue.indexOf(';') !== -1) {
          inputArray = this.inputValue.split(';')
        }
        if (inputArray.length !== 0) {
          this.patientInfoForm.patName = inputArray[0]
          this.patientInfoForm.patSex = inputArray[1] === '男' ? '1' : '0'
          this.patientInfoForm.patAge = parseInt(inputArray[2])
          this.patientInfoForm.patTellphone = inputArray[3]
          this.patientInfoForm.patAddress = inputArray[4]
          let params = [
            inputArray[5],
            inputArray[6]]
          this.$emit('caseInfoMessage', params)
        } else {
          this.patientInfoForm.patName = this.inputValue
        }
      }
    }
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .inputWidth
    width 200px
</style>



// WEBPACK FOOTER //
// src/components/case/caseManager/addCase/PatientInfo.vue